import React, {Component} from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SaveIcon from '@mui/icons-material/Save';
import Select from '../tools/Select';
import Grid from '@mui/material/Grid';
import DatePicker from '../tools/DatePicker';
import app from '../base/api';
import { matchPath } from "react-router";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TimePicker from '@mui/lab/TimePicker';
import DeleteIcon from '@mui/icons-material/Delete';/*Tarea GDM-700 */
import ConfirmDialog from '../confirmDialog';
const theme = createTheme(
  /*Tarea GDM-700 - Inicio */
  {
  palette: {
    secondary: {
      main: '#f44336',
    },

  },
}
/*Tarea GDM-700 - Fin */
);

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction

    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],

    ['clean']                                         // remove formatting button
  ],
}

class RecordBase extends Component {

  constructor () {
    super();
    const match = matchPath("/dashboard/:cls/:id", window.location.pathname);
    this.state = {
      id: match ? match.params.id : null,
      record: {},
      fields: {},
      error: '',
      message: '',
      cls: '',
      /*Tarea GDM-700 - Inicio */
      botondelete: true,
      botonsave: true,
      botonvolver: true,
      estadosave:false,
      new: match ? match.params.id === "new" : false,
      setConfirmOpen:false
      /*Tarea GDM-700 - Fin */
    };
  }

  async componentDidMount ()  {
    await this.getFields();
    if (this.state.id !== 'new') this.fetchData();
  }

  fetchData = async () => {
    let data = await app.get(`/api/tables/${this.state.cls}/${this.state.id}`);
    this.setState({record: data})
  }

  getFields = async () => {
    let data = await app.get(`/api/fields/${this.state.cls}/`, null, this.addError);
    let record = {};
    for (let fieldName in data){
      record[fieldName] = null;
      let field = data[fieldName];
      if (field.editor === 'datetime') record[fieldName] = new Date();
      if (field.editor === 'date') record[fieldName] = new Date();
    }
    this.setState({record: record, fields: data})
  }

  /*Tarea GDM-700 - Inicio */
  getRecord = async (name) => {
    let data = await app.get(`/api/tables/${this.state.cls}/${name}`);
    return data
  }
   /*Tarea GDM-700 - Fin */

  addError = async (err) => {
    let e = await err.text();
    try {
      e = JSON.parse(e);
    } catch {}
    if (e.errors && e.errors.length>0) e = e.errors[0].message;
    if (e.name) e = e.name;
    this.setState({error: e})
  }

  save = async () => {
    /*Tarea GDM-700 - Inicio */
    if(this.state.record.hasOwnProperty('Config')){
      let email= this.state.record.Config
      let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
      if (!emailRegex.test(email)) {
        this.setState({error: 'Email con formato incorrecto'})
        return
      }else{
        let dato = await this.getRecord(email);
        if(dato !== null && !this.state.record.IdConfig){
          this.setState({error: 'El email ya existe'});
          return;
        }
        var form = new FormData();
        form.append('data', JSON.stringify(this.state.record));
        let data = await app.post(`/api/tables/${this.state.cls}/`, form, {}, this.addError);
        if (data) {
          this.setState({record: data, message: 'Registro Guardado Correctamente'})
          this.setState({ botonsave: true })
          this.setState({ estadosave: true })
          this.setState({ botondelete: true })
        }
      }
    }else{
        if(this.state.cls==='usuarios'){
          let record = this.state.record;
          record['idPermisoUsuario'] = 1;
        }
        /*Tarea GDM-700 - Fin */
        var form = new FormData();
        form.append('data', JSON.stringify(this.state.record));
        let data = await app.post(`/api/tables/${this.state.cls}/`, form, {}, this.addError);
        if(this.state.cls==='usuarios'){
          data.Password = '';
        }
        if (data) {
          this.setState({record: data, message: 'Registro Guardado Correctamente'})/*Tarea GDM-700 traduccion*/
          this.setState({ botonsave: true })
          this.setState({ estadosave: true })
          this.setState({ botondelete: true })
        }
    /*Tarea GDM-700 - Inicio */
    }
    /*Tarea GDM-700 - Fin */
  }
  /*Tarea GDM-700 - Inicio */
  remove = async () => {
    /*Tarea GDM-700 - Inicio */
    let id
    if(this.state.id!=='new'){
      id = this.state.id
    }else{
      if(this.state.record.idUsuario){
        id = this.state.record.idUsuario
      }
      if(this.state.record.idBusBase){
        id = this.state.record.idBusBase
      }
      if(this.state.record.idBusTipo){
        id = this.state.record.idBusTipo
      }
      if(this.state.record.IdConfig){
        id = this.state.record.IdConfig
      }
      if(this.state.record.idCotizacion){
        id = this.state.record.idCotizacion
      }
      if(this.state.record.idPrecio){
        id = this.state.record.idPrecio
      }
      if(this.state.record.idMailTemplate){
        id = this.state.record.idMailTemplate
      }
    }
    let data = await app.remove(`/api/tables/${this.state.cls}/`, id, this.addError);
    /*Tarea GDM-700 - Fin */
    if (data) {
      this.setState({record: data, message: 'Registro Borrado Correctamente'});
    }
    this.setState({ botonvolver: true });
    this.setState({ botonsave: false });
    this.setState({ botondelete: false });
    this.setState({setConfirmOpen:false})
  }
  esUnNumero = (id) => {
    return Number.isInteger(parseInt(id))
  }
  setConfirmOpen = (state) =>{
    this.setState({setConfirmOpen:state})
  }
  setOpen = () =>{
    this.setState({setConfirmOpen:false})
  }
  /*Tarea GDM-700 - Fin */
  handleChange = (event, value) => {
    this.setState({
      error:''
    })
    let record = this.state.record;
    record[event.target.id] = event.target.value;
    if (this.state.fields[event.target.id].editor == 'checkbox') {
      record[event.target.id] = value;
    }
    this.setState({
      record: record
    });
  }

  buttonActions = () => {
    return [];
  }


  render () {
    /*Tarea GDM-700 - Inicio */
    const ruta = '/dashboard/'+this.state.cls;
    const {setConfirmOpen,estadosave,botonsave,botonvolver,id} = this.state;
    let {botondelete} = this.state;
    const displayflex = {
      display: 'flex',
      color: '#fff',
      margin:'20px 0 20px 0'
    };
    const displayflex2 = {
      display: 'block'
    };
    const displaynone = {
      display: 'none'
    };
    if(id==='new' && estadosave==false){
      botondelete=false;
    }
    const displaybtnsave = botonsave?displayflex:displaynone;
    const displaysel = botonsave?displayflex2:displaynone;
    const displaybtndelete = botondelete?displayflex:displaynone;
    const displaybtnvolver = botonvolver?displayflex:displaynone;
    /*Tarea GDM-700 - Fin */
  
    let errorDiv;
    if (this.state.error) {
      errorDiv = <Alert onClose={() => {this.setState({error: ''})}} severity="error">{this.state.error}</Alert>;
    }
    let messageDiv;
    if (this.state.message) {
      messageDiv = <Alert onClose={() => {this.setState({message: ''})}} severity="success">{this.state.message}</Alert>;
    }
    var rows = [];
    for (let fieldName in this.state.fields) {

      const fieldsSkip = ['Version', 'CreadoUTC', 'ModificadoUTC', 'CreadoUsuarioId', 'ModificadoUsuarioId'];
      if (fieldsSkip.indexOf(fieldName)>-1) continue;
      let field = this.state.fields[fieldName];
      if (fieldName === 'id') field.readOnly = true;
      if (fieldName.substring(0,2) === 'id' /*Tarea GDM-700 - Inicio*/|| fieldName.substring(0,2) === 'Id'/*Tarea GDM-700 - Fin*/) field.readOnly = true;
      if (fieldName=='idPermisoUsuario') field.readOnly = false;/*Tarea GDM-700*/
      if (field.richText) {
        rows.push(<Grid key={fieldName} style={displaysel}/*Tarea GDM-700 */ item xs={12}>
          <ReactQuill theme="snow"
          key={fieldName}
          value={this.state.record[fieldName] || ''}
          onChange={this.handleQuillChange}
          modules={modules}
          />
        </Grid>)
      } else if (field.editor === 'datetime') {
        rows.push(<Grid key={fieldName} item xs={4}>
          <DatePicker
            style={displaybtnsave}/*Tarea GDM-700 */
            inputFormat="datetime"
            disabled={field.readOnly}
            id={fieldName}
            value={this.state.record[fieldName] || ''}
            onChange={this.handleChange}
            label={field.label || fieldName}
          />
        </Grid>)
      } else if (field.editor === 'time') {
        rows.push(
        <Grid key={fieldName} item xs={4}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimePicker
              style={displaybtnsave}/*Tarea GDM-700 */
              id={fieldName}
              value={this.state.record[fieldName] || null}
              disabled={field.readOnly}
              onChange={value => {this.handleChange({target: {id: fieldName, value}})}}
              label={field.label || fieldName}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Grid>
        )
      } else if (field.editor === 'date') {
        rows.push(<Grid key={fieldName} item xs={4}>
          <DatePicker
            style={displaybtnsave}/*Tarea GDM-700 */
            inputFormat="date"
            disabled={field.readOnly}
            id={fieldName}
            value={this.state.record[fieldName]}
            onChange={this.handleChange}
            label={field.label || fieldName}
          />
        </Grid>)
      } else if (field.editor === 'select') {
        rows.push(<Grid key={fieldName} style={displaysel} item xs={4}>{/*Tarea GDM-708 style={displaybtnsave} */}
          <Select
            id={fieldName}
            values={field.values}
            disabled={field.readOnly}
            relation={field.relation}
            value={this.state.record[fieldName] || '1'}/*Tarea GDM-708 sse cambio '' por '1' */
            onChange={this.handleChange}
            label={field.label || fieldName}
          />
        </Grid>)
      } else if (field.editor === 'checkbox') {
        rows.push(<Grid key={fieldName} item xs={4}>
          <FormControlLabel
            label={field.label || fieldName}
            control={
              <Checkbox
                style={displaybtnsave}/*Tarea GDM-700 */
                id={fieldName}
                disabled={field.readOnly}
                checked={this.state.record[fieldName] || false}
                value={this.state.record[fieldName] || false}
                onChange={this.handleChange}
                label={field.label || fieldName}
              />
            }
          />
        </Grid>)
      } else if (field.editor == 'textarea') {
        rows.push(
          <Grid key={fieldName} style={displaybtnsave}/*Tarea GDM-700 */ item xs={12}><TextField
            margin="normal"
            key={fieldName}
            multiline
            required={field.allowNull === false}
            disabled={field.readOnly}
            fullWidth
            rows={20}
            type={field.editor || 'text'}
            id={fieldName}
            value={this.state.record[fieldName] || ''}
            onChange={this.handleChange}
            label={field.label || fieldName}
          /></Grid>
        )
      }
      /*Tarea GDM-700 - Inicio */
      else if(fieldName=='Config'){
        rows.push(
          <Grid key={fieldName} item xs={8}><TextField
            margin="normal"
            style={displaybtnsave}/*Tarea GDM-700 */
            key={fieldName}
            required={field.allowNull === false}
            disabled={field.readOnly}
            fullWidth
            type={field.editor || 'text'}
            id={fieldName}
            value={this.state.record[fieldName] || ''}
            onChange={this.handleChange}
            label={field.label || fieldName}
          /></Grid>
      )
        }else if(fieldName=='IdConfig'){
          rows.push(
            <Grid key={fieldName} item xs={4}><TextField
              margin="normal"
              style={displaybtnsave}/*Tarea GDM-700 */
              key={fieldName}
              required={field.allowNull === false}
              disabled={field.readOnly}
              fullWidth
              type={field.editor || 'text'}
              id={fieldName}
              value={this.state.record[fieldName] || ''}
              onChange={this.handleChange}
              label={field.label || fieldName}
            /></Grid>
      )
        } 
        /*Tarea GDM-700 - Fin */
        else {
        rows.push(
          <Grid key={fieldName} item xs={4}><TextField
            margin="normal"
            style={displaybtnsave}
            key={fieldName}
            required={field.allowNull === false}
            disabled={field.readOnly}
            fullWidth
            type={field.editor || 'text'}
            id={fieldName}
            value={this.state.record[fieldName] || ''}
            onChange={this.handleChange}
            label={field.label || fieldName}
          /></Grid>
        )
      }

    }
      return (
        /*Tarea GDM-700 - Inicio */
        <div>
          <div>
              <ConfirmDialog
                title="Borrar registro"
                open={setConfirmOpen}
                setOpen={this.setOpen}
                onConfirm={this.remove}
              >
              Esta seguro de borrar este registro?
            </ConfirmDialog>
          </div>
          {/*Tarea GDM-700 - Fin */}
          <ThemeProvider theme={theme}>
            <Container component="main">
              <CssBaseline/>
              <Box
                sx={{
                  marginTop: 8,
                  display: 'flex',
                  width: '1000px',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Typography component="h1" variant="h5">
                  {this.title}
                </Typography>
                {errorDiv}
                {messageDiv}
                <Box noValidate  sx={{ mt: 1 }}>
                  <Grid container spacing={2}>
                    {rows}
                  </Grid>
                  {/*Tarea GDM-700 - Inicio */}
                    <Button
                    type="button"
                    style={displaybtnvolver}
                    href={ruta}
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                
                    >
                      Volver
                    </Button>
                  {/*Tarea GDM-700 - Fin */}
                    <Button
                    type="button"
                    style={displaybtnsave}
                    onClick={this.save}
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    <SaveIcon />
                  </Button>
                  {/*Tarea GDM-700 - Inicio */}
                  <Button
                    type="button"
                    style={displaybtndelete}
                    onClick={()=>this.setConfirmOpen(true)}
                    fullWidth
                    color="secondary"
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    <DeleteIcon />
                  </Button>
                  {/*Tarea GDM-700 - Fin */}
                  {this.buttonActions()}
                </Box>
              </Box>
            </Container>
          </ThemeProvider>
          {/*Tarea GDM-700 - Inicio */}
        </div>
        /*Tarea GDM-700 - Fin */
      );
  }
}

export default RecordBase;
